module.exports = __webpack_public_path__ + "static/img/13.cc03f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2024112/13.png
// module id = +Sl3
// module chunks = 0